/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum EducationDegree {
  AA = "AA",
  AS = "AS",
  BA = "BA",
  BS = "BS",
  BSC = "BSc",
  DRJUR = "Dr.Jur.",
  FSE = "First State Exam",
  MA = "MA",
  MAGJUR = "Mag.Jur.",
  MBA = "MBA",
  MD = "MD",
  MLIS = "MLIS",
  MS = "MS",
  MSC = "MSc",
  PGCERT = "PGCert",
  PGDIP = "PGDip",
  PharmD = "PharmD",
  PHD = "PHD",
  QLTS = "QLTS",
  SQE1 = "SQE1",
  SQE2 = "SQE2",
  SSE = "Second State Exam",
  BCL = "BCL",
  BVC = "BVC",
  DIPLJUR = "Dipl.Jur.",
  DIPLWIJUR = "Dipl.-Wi.Jur.",
  GDL = "GDL",
  JD = "JD",
  LLB = "LLB",
  LLM = "LLM",
  LPC = "LPC",
  PCLL = "PCLL",
}

export const EducationDegreeDisplay: Record<EducationDegree, string> = {
  [EducationDegree.AA]: "Associate of Arts",
  [EducationDegree.AS]: "Associate of Science",
  [EducationDegree.BA]: "Bachelor of Arts",
  [EducationDegree.BS]: "Bachelor of Science",
  [EducationDegree.BSC]: "Bachelor of Science",
  [EducationDegree.DRJUR]: "Doctor Juris",
  [EducationDegree.FSE]: "First State Exam",
  [EducationDegree.MA]: "Master of Arts",
  [EducationDegree.MAGJUR]: "Magister Juris",
  [EducationDegree.MBA]: "Master of Business Administration",
  [EducationDegree.MD]: "Doctor of Medicine",
  [EducationDegree.MLIS]: "Master of Library and Information Science",
  [EducationDegree.MS]: "Master of Science",
  [EducationDegree.MSC]: "Master of Science",
  [EducationDegree.PGCERT]: "Postgraduate Certificate",
  [EducationDegree.PGDIP]: "Postgraduate Diploma",
  [EducationDegree.PharmD]: "Doctor of Pharmacy",
  [EducationDegree.PHD]: "Doctor of Philosophy",
  [EducationDegree.QLTS]: "Qualified Lawyers Transfer Scheme",
  [EducationDegree.SQE1]: "Solicitors Qualifying Examination 1",
  [EducationDegree.SQE2]: "Solicitors Qualifying Examination 2",
  [EducationDegree.SSE]: "Second State Exam",
  [EducationDegree.BCL]: "Bachelor of Civil Law",
  [EducationDegree.BVC]: "Bar Vocational Course",
  [EducationDegree.DIPLJUR]: "Diplom-Jurist",
  [EducationDegree.DIPLWIJUR]: "Diplom-Wirtschaftsjurist",
  [EducationDegree.GDL]: "Graduate Diploma in Law",
  [EducationDegree.JD]: "Juris Doctor",
  [EducationDegree.LLB]: "Bachelor of Laws",
  [EducationDegree.LLM]: "LLM Master of Laws",
  [EducationDegree.LPC]: "Legal Practice Course",
  [EducationDegree.PCLL]: "Postgraduate Certificate in Laws",
};
